// Ricerca a più parole, uguale per filtri ed evidenziazione: senza maiuscole né accenti,
// e ogni parola (separata da spazio) deve comparire (AND), anche in campi diversi.

/** Testo senza accenti e in minuscolo. */
export const foldText = (text) => String(text ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();

/** Le parole da cercare: testo digitato -> elenco di parole normalizzate (vuoto se non c'è nulla). */
export const searchTerms = (query) => foldText(query).trim().split(/\s+/).filter(Boolean);

/** Il testo contiene tutte le parole? Senza parole, sì. */
export const matchesAllTerms = (text, terms) => {
  if (terms.length === 0) return true;
  const folded = foldText(text);
  return terms.every((term) => folded.includes(term));
};

/**
 * Pezzi di `text` con l'indicazione di quali sono da evidenziare:
 * [{ text, match }]. Le occorrenze di parole diverse che si sovrappongono si fondono.
 */
export const highlightParts = (text, terms) => {
  const source = String(text ?? '');
  if (source === '' || terms.length === 0) return [{ text: source, match: false }];

  // Testo normalizzato con, per ogni suo carattere, la posizione nel testo originale
  // (togliere gli accenti può cambiare la lunghezza).
  let folded = '';
  const origin = [];
  for (let i = 0; i < source.length; i += 1) {
    const piece = foldText(source[i]);
    for (let k = 0; k < piece.length; k += 1) origin.push(i);
    folded += piece;
  }

  const ranges = [];
  terms.forEach((term) => {
    let from = folded.indexOf(term);
    while (from !== -1) {
      ranges.push([origin[from], origin[from + term.length - 1] + 1]);
      from = folded.indexOf(term, from + term.length);
    }
  });
  if (ranges.length === 0) return [{ text: source, match: false }];

  ranges.sort((a, b) => a[0] - b[0]);
  const merged = [ranges[0].slice()];
  ranges.slice(1).forEach(([start, end]) => {
    const last = merged[merged.length - 1];
    if (start <= last[1]) last[1] = Math.max(last[1], end);
    else merged.push([start, end]);
  });

  const parts = [];
  let cursor = 0;
  merged.forEach(([start, end]) => {
    if (start > cursor) parts.push({ text: source.slice(cursor, start), match: false });
    parts.push({ text: source.slice(start, end), match: true });
    cursor = end;
  });
  if (cursor < source.length) parts.push({ text: source.slice(cursor), match: false });
  return parts;
};
